import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";

interface PosConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "delete" | "logout" | "default";
}

const PosConfirmModal: React.FC<PosConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  title = "Are you sure?",
  description = "This action cannot be undone.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "default",
}) => {
  const isDelete = variant === "delete";
  const isLogout = variant === "logout";

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent
        className={cn(
          "bg-[var(--pos-primary-background-color)] rounded-[12px] shadow-[0px_8px_8px_-4px_#10182808] border border-[var(--pos-layout-border-color)] text-center p-6",
          "w-[90%] sm:w-full max-w-sm",
          "mx-auto my-10 sm:my-0"
        )}
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="text-[16px] leading-[18px] sm:text-xl font-bold text-[var(--pos-primary-text-color)]">
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-[13px] leading-5 font-normal text-[var(--pos-secondary-text-color)]">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex flex-row justify-center items-center gap-2">
          <AlertDialogCancel
            className={cn(
              "w-full sm:w-auto border-0 bg-[var(--pos-secondary-background-color)] hover:bg-[var(--pos-primary-background-hover-color)] text-[var(--pos-secondary-text-color)] text-[13px] leading-5 font-medium px-4 h-[38px] rounded-[4px] transition-colors mt-0"
            )}
          >
            {cancelText}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className={cn(
              "w-full sm:w-auto h-[38px] flex items-center justify-center text-[13px] font-medium leading-[15px] text-white px-4 rounded-[4px] transition-colors",
              isDelete
                ? "bg-[#D83A52] hover:bg-[#B63546]"
                : isLogout
                ? "bg-[var(--pos-primary-color)] hover:bg-[#9f0e0e]"
                : "bg-gray-800 hover:bg-gray-700"
            )}
          >
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default PosConfirmModal;
